import FJPoolCanvas from '../core/FJPool/FJPoolCanvas';
import FJPoolImage from '../core/FJPool/FJPoolImage';
import FJPoolVideo from '../core/FJPool/FJPoolVideo';

// 项目中已经存在一个 FJCanvasPool, 但是里面的接口跟输出业务耦合，比如 clear
// 所以这里新建一个通用的池单例，用于其他的应用场景
const _canvasPool = new FJPoolCanvas();
const _imagePool = new FJPoolImage();
const _videoPool = new FJPoolVideo();

/**
 * 获取画布
 *
 * @param {string} contextType
 * @returns
 */
function getCanvas(contextType = '2d') {
    return _canvasPool.getItem({ contextType });
}

/**
 * 释放画布
 *
 * @param {HTMLCanvasElement} canvas
 */
function releaseCanvas(canvas) {
    _canvasPool.releseItem(canvas);
}

/**
 * 获取图片
 *
 * @returns
 */
function getImage() {
    return _imagePool.getItem();
}

/**
 * 释放图片
 *
 * @param {Image} image
 */
function releaseImage(image) {
    _imagePool.releseItem(image);
}

/**
 * 获取图片
 *
 * @returns
 */
function getVideo() {
    return _videoPool.getItem();
}

/**
 * 释放图片
 *
 * @param {HTMLVideoElement} video
 */
function releaseVideo(video) {
    _videoPool.releseItem(video);
}

export default {
    getCanvas,
    getImage,
    releaseCanvas,
    releaseImage,
    getVideo,
    releaseVideo,
};
